import React from 'react'
import { Container } from './styled'

type Props = {
  value: string
}

export const ActionCardInformation = ({ value }: Props) => {
  return (
    <Container>
      <span>{value}</span>
    </Container>
  )
}
